import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // adjust the import path

const ProtectedRoute = ({ children, requiredPermission }) => {
  const { loading, isAuthenticated, permissions } = useAuth();
  console.log(!permissions.includes(requiredPermission));
  console.log(permissions);
  // If auth is still loading, show a loader (prevents flash of redirect)
  if (loading) {
    return <div className="loader">Loading...</div>; // or a spinner
  }

  // Not logged in → go to login
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Permission required but not present → go to unauthorized page
  // if (requiredPermission && !permissions.includes(requiredPermission)) {
  //   return <Navigate to="/" replace />;
  // }

  // All good – render the protected content
  return <>{children}</>;
};

export default ProtectedRoute;
